module.exports = "/images/img_placeholder.webp?90bc7526004ebe8e94475273dc25ff92";